import React from 'react'
import Box from '@material-ui/core/Box'

import { Modal, ModalHeader, ModalSubHeader, ModalContent } from './index'
import { Button } from '../Button'

export const DownloadingPdfModal = ({ open, close }) => {
  return (
    <Modal open={open} onClose={close}>
      <ModalHeader>Creating your report</ModalHeader>
      <ModalSubHeader>We're just getting your papers in order.</ModalSubHeader>
      <ModalContent>
        <p className='text-center'>Your report will download in a moment. You can click the close button to hide this message in the meantime.</p>
        <Box
          display='flex'
          justifyContent='center'
        >
          <Button primary onClick={close}>Close</Button>
        </Box>
        <Box
          mt='1rem'
          display='flex'
          justifyContent='center'
          alignItems='center'
          flexDirection='column'
        >
          <small>The PDF report is based on the time value you have selected on your dashboard.</small>
          <small>If you selected to view the dashboard in PV, the report will also be in PV.</small>
        </Box>
      </ModalContent>
    </Modal>
  )
}
